import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedSection.css';

const FeaturedSection = ({ title, buttonText, imageUrl, linkTo, reverse, btnLink, modelId, children }) => {
    return (
        <section className={`featured-section ${reverse ? 'reverse' : ''}`}>
            <div className="image-content">
                <Link className="link" to={linkTo}>
                    <img src={imageUrl} alt={title} />
                </Link>
                {modelId && (
                    <Link className="link" to={`/model/${modelId}`}>
                        <button className="hire-model-button">Hire Model</button>
                    </Link>
                )}
            </div>
            <div className="text-content">
                <p className="text-content-title">{title}</p>
                <div className="text-content-description">
                    {children}
                </div>
                <Link className="link" to={btnLink}>
                    <button className="section-button">{buttonText}</button>
                </Link>
            </div>
        </section>
    );
};

export default FeaturedSection;